<template>
  <div v-loading.fullscreen.lock="loading" class="mainContent" :data-stats-topic="statsTopic">
    <div class="left" :style="!isEnd ? getLeftWidth : ''" :class="selectedQidSmall == 0 ? 'forewordLeft' : ''">
      <!-- 题干 -->
      <div class="stem" :class="currentTheme && !currentQSmall.contentWidth ? 'pipan' : ''">
        <!-- 步骤 -->
        <div class="tab">
          <div v-for="(item, index) in examList" :key="item.id">
            <div
              class="tag top"
              :style="{ 'z-index': 7 - index }"
              :class="item.active ? 'ttabActive' : ''"
              v-if="index === 0"
            >
              {{ item.title }}
            </div>
            <div
              class="tag"
              :style="{ 'z-index': 7 - index, 'margin-bottom': index === tabList.length - 1 ? 0 : '' }"
              :class="item.active ? 'otabActive' : ''"
              v-else
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="step">
          <div class="task" v-for="item of qidList" :key="item.qid">
            <div class="taskId" v-if="item.title">{{ item.title }}</div>
            <div
              class="qId"
              :class="{
                selected: itemSmall.active,
                piPan: currentTheme,
                answered: $store.getters.answerList.indexOf(itemSmall.id) > -1 && itemSmall.id < selectedQidSmall
              }"
              v-for="itemSmall of item.small"
              :key="itemSmall.id"
              @click="goPage(itemSmall.id)"
            >
              {{ itemSmall.title }}
            </div>
          </div>
        </div>
        <template v-if="selectedQidSmall != 0 && currentQSmall.stemContent && currentQSmall.stemContent.length !== 0">
          <img :src="themeList[currentTheme]['--title-bg-img']" class="headline" alt="" />
          <div
            v-for="item in tabList"
            :key="item.id"
            style="height: 20px; display: inline-block; color: #fff; position: absolute; top: 30px"
          >
            <img
              v-if="item.active && currentTheme === 0"
              width="14"
              src="./../../../../assets/exam/icon@2x.png"
              alt=""
              srcset=""
            />
            <span v-if="item.active && currentTheme === 0" style="margin-left: 10px; font-size: 16px">{{
              item.name0
            }}</span>
          </div>
          <div class="content">
            <div class="issue">
              <template v-for="(item, itemIndex) of currentQSmall.stemContent">
                <div
                  class="label"
                  v-if="item.type === 'textArray'"
                  :key="item.type + itemIndex"
                  :class="steerObj && steerObj.leftModelSteer ? 'steerBorder' : ''"
                >
                  <img
                    v-if="steerObj && steerObj.leftModelSteer"
                    class="image_steerBorder_bg"
                    :src="steerObj.leftbg"
                    alt=""
                  />
                  <div class="head">
                    <span>{{ item.label }}</span>
                    <i @click="textShow(itemIndex)" :class="item.down ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                  </div>
                  <div
                    class="list"
                    v-for="(child, cindex) of item.value"
                    :key="cindex"
                    :style="{ textAlign: item.textAlign, borderTop: cindex === 0 ? '1px dashed #979797' : '' }"
                    :class="!item.down ? 'min' : ''"
                  >
                    <p
                      :style="{ textIndent: child.type !== 'noTextIndent' ? '2em' : '', textAlign: child.textAlign }"
                      :class="[child.type]"
                      v-html="child.text"
                    ></p>
                    <p v-if="child.video">{{ child }}</p>
                    <div :class="steerObj && steerObj.videoModelSteer ? 'steerBorder' : ''">
                      <VideoModule
                        v-if="child.type === 'video'"
                        :onlyId="'video' + currentQSmall.id + child.id"
                        :hasVideoButton="child.hasVideoButton"
                        :videoArr="child.value"
                        :key="cindex"
                        :steerObj="steerObj"
                      >
                      </VideoModule>
                      <img
                        v-if="child.type === 'video' && steerObj && steerObj.videoModelSteer"
                        class="image_steerVideoBorder_bg"
                        :src="steerObj.leftbg"
                        alt=""
                      />
                    </div>
                    <div
                      class="image"
                      :class="steerObj && steerObj.imgModelSteer ? 'steerBorder' : ''"
                      @click="showImg(child)"
                      v-if="child.img"
                    >
                      <img
                        v-if="steerObj && steerObj.imgModelSteer"
                        class="image_steerBorder_bg"
                        :src="steerObj.leftbg"
                        alt=""
                      />
                      <img
                        v-if="steerObj && steerObj.imgModelSteer"
                        class="image_steerButton_bg"
                        :src="require('@/assets/exam/button_kuang.png')"
                        alt=""
                      />
                      <img :style="{ width: child.isBig ? '90%' : '' }" :src="child.img" alt="" />
                      <div v-if="currentTheme && !child.isBig" class="icon">
                        <img :src="require('@/assets/exam/button_fangda.png')" alt="" />
                      </div>
                      <div v-html="child.legend" v-if="child.legend"></div>
                    </div>
                  </div>
                </div>
                <div
                  class="list"
                  ref="stormwater"
                  v-else-if="'stormwater, innovation'.includes(item.type)"
                  :key="item.type + itemIndex"
                >
                  <div class="schoolImg" :class="steerObj && steerObj.leftModelSteer ? 'steerBorder' : ''">
                    <img
                      v-if="steerObj && steerObj.imgModelSteer"
                      class="image_steerBorder_bg"
                      :src="steerObj.leftbg"
                      alt=""
                    />
                    <img
                      @click="showSchool(item.type)"
                      :src="item.value"
                      alt=""
                      :data-click-stats="
                        !showBigImg
                          ? 'click_school_image_zoom_in#点击图片放大按钮'
                          : 'click_school_image_zoom_out#点击图片缩小按钮'
                      "
                    />
                    <img
                      class="icon"
                      v-if="!showBigImg"
                      @click="showSchool(item.type)"
                      :src="require('@/assets/exam/button_fangda.png')"
                      alt=""
                      data-click-stats="click_school_image_zoom_in#点击图片放大按钮"
                    />
                    <img
                      class="icon"
                      v-else
                      @click="showSchool(item.type)"
                      :src="require('@/assets/exam/icon_suoxiao.png')"
                      alt=""
                      data-click-stats="click_school_image_zoom_out#点击图片缩小按钮"
                    />
                    <div
                      class="school_dot"
                      :class="{ school_dot_no_flag: !it.icon }"
                      :style="{ left: it.x, top: it.y }"
                      @click="schoolClick(index, item.imgArr, item.type, it)"
                      v-for="(it, index) in item.imgArr"
                      :key="it.imgUrl"
                      :data-click-stats="it.statsName && `click_${it.statsName}#点击${it.name}旗子`"
                    >
                      <img src="./../../../../assets/exam/qizi_icon@2x.png" alt="" srcset="" />
                      <div
                        v-if="item.type !== 'stormwater' && it.isShow"
                        class="line"
                        :style="{ left: it.lineLeft, top: it.lineTop, transform: 'rotate(' + it.transform + 'deg)' }"
                      ></div>
                      <div
                        v-if="item.type !== 'stormwater' && it.isShow"
                        class="dot_name"
                        :style="{ left: it.textLeft, top: it.textTop }"
                      >
                        {{ it.name }}
                      </div>
                      <span v-if="item.type === 'stormwater'">{{ it.name }}</span>
                    </div>
                  </div>
                  <!-- {{videoUrl}} -->
                  <div class="video" v-if="videoUrl">
                    <i class="el-icon-circle-close" @click="schoolVideoClose"></i>
                    <video
                      autoplay
                      loop
                      :src="videoUrl"
                      controlslist="nodownload"
                      data-xxx
                      controls
                      @webkitfullscreenchange="fullscreenchange"
                    ></video>
                  </div>
                </div>
                <div
                  class="list"
                  v-else-if="item.type === 'text'"
                  :key="itemIndex"
                  :style="{
                    textAlign: item.textAlign,
                    textIndent: !item.noTextIndent ? '2em' : '',
                    fontWeight: item.fontWeight ? 'bold' : '',
                    fontFamily: item.fontFamily ? '楷体' : ''
                  }"
                  v-html="item.value"
                ></div>
                <div
                  class="list text_abstract"
                  v-else-if="item.type === 'text_abstract'"
                  :key="itemIndex"
                  v-html="item.value"
                ></div>
                <template v-else-if="item.type === 'video'">
                  <VideoModule
                    :ref="'video' + currentQSmall.id + item.id"
                    :onlyId="'video' + currentQSmall.id + item.id"
                    :hasVideoSlider="item.hasVideoSlider"
                    :hasVideoButton="item.hasVideoButton"
                    :videoArr="item.value"
                    :key="itemIndex"
                  ></VideoModule>
                </template>
                <div class="list" v-else-if="item.type === 'array'" :key="itemIndex">
                  <div
                    class="image_steerBorder_bubble_bg"
                    v-if="submitList.length === 0 && steerObj && steerObj.leftModelSteer"
                  >
                    <img v-for="leftbg of steerObj.leftbg" :key="leftbg" :src="leftbg" alt="" />
                  </div>
                  <div
                    class="answerList"
                    :style="{ background: it.noCanMove ? '#eee' : '' }"
                    v-for="(it, index) of submitList"
                    :key="index"
                  >
                    <div class="image_steerBorder_bg" v-if="index === 0 && steerObj && steerObj.leftModelSteer">
                      <img v-for="leftbg of steerObj.leftbg" :key="leftbg" :src="leftbg" alt="" />
                    </div>
                    <div
                      draggable="true"
                      @dragstart="dragstart(it.index, 'push', $event)"
                      @dragend="dragend('', it.index, 'push', $event)"
                      :data-stats-var="`0-${it.index}`"
                    >
                      <span v-if="!it.isMove" v-html="it.index + '.' + it.title"></span>
                      <!-- <span v-if="!it.isMove" v-html="it.title"></span> -->
                    </div>
                  </div>
                </div>
                <div class="list" v-else-if="item.type === 'draw'" :key="itemIndex">
                  <img
                    height="200"
                    :src="historyData[historyData.length - 1].url"
                    v-if="item.value === 'img' && historyData.length > 0"
                    alt=""
                    srcset=""
                  />
                </div>
                <div
                  v-else
                  class="list"
                  :class="[item.isSmall ? 'img_small' : '', steerObj && steerObj.leftModelSteer ? 'steerBorder' : '']"
                  :key="itemIndex"
                >
                  <div
                    v-if="!item.isSmall"
                    @click="showImg(item)"
                    :data-click-stats="item.dontStats ? undefined : 'img_zoom_in'"
                  >
                    <img
                      v-if="steerObj && steerObj.leftModelSteer"
                      class="image_steerBorder_bg"
                      :src="require('@/assets/exam/kuang_up.png')"
                      alt=""
                    />
                    <img :style="{ width: item.isBig ? '90%' : '' }" :src="item.value" alt="" />
                    <div v-if="(currentTheme && !item.isBig) || (!currentTheme && item.isSmall)" class="icon">
                      <img :src="require('@/assets/exam/button_fangda.png')" alt="" />
                    </div>
                  </div>
                  <div
                    :style="{ width: 100 / item.value.length + '%' }"
                    @click="showImg(img)"
                    v-else
                    v-for="img in item.value"
                    :key="img.img"
                    :data-click-stats="item.dontStats ? undefined : 'img_zoom_in'"
                    :data-image-kind="img.imageKind"
                  >
                    <img
                      v-if="steerObj && steerObj.leftModelSteer"
                      class="image_steerBorder_bg"
                      :src="require('@/assets/exam/kuang_up.png')"
                      alt=""
                    />
                    <img :src="img.img" alt="" />
                    <div class="icon">
                      <img :src="require('@/assets/exam/button_fangda.png')" alt="" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="selectedQidSmall == 0">
          <ForewordEnergy />
        </template>
      </div>
    </div>
    <div v-if="selectedQidSmall === 0"></div>
    <div class="right" :style="getRightWidth" v-else-if="!isEnd">
      <div class="headline">
        <img :src="themeList[currentTheme]['--main-right-title']" alt="" />
      </div>
      <div class="answer">
        <div ref="answer">
          <template v-for="itemDesc of currentQSmall.desc">
            <div
              class="title"
              :class="steerObj && steerObj.titleModelSteer ? 'steerBorder' : ''"
              v-html="itemDesc"
              :key="itemDesc"
            ></div>
          </template>
          <!-- <div class="desc" v-if="currentQSmall.durationTime !== 100">* 作答时间 {{ currentQSmall.durationTime }} 分钟。</div> -->
          <div class="countDown" v-if="currentQSmall.durationTime !== 100">
            <span>{{ time }}</span>
            <div class="progress">
              <div class="over" :style="{ width: progress }"></div>
              <div class="current" :style="{ left: progress }"></div>
            </div>
            <span style="margin-left: 10px">{{ currentQSmall.durationTime }}分钟</span>
          </div>
          <template v-for="(item, itemIndex) of currentQSmall.askList">
            <div
              :class="item.className"
              :style="item.type === 11 ? 'width: 45%;' : ''"
              :key="currentQSmall.id + String(item.id)"
            >
              <!--
              1: 文字录入；
              2：标题显示；
              3：图片显示；
              4：单分类;
              5：单选；
              6：多选;
              7 | 9: 图形变换；
              10: 绘图；
              11: 视频；
              12: 数据演示
            -->
              <template v-if="item.type === 1">
                <img
                  :class="
                    steerObj.rightbgType === 'up'
                      ? 'steer_bg_up_kuang'
                      : steerObj.rightbgType === 'left'
                      ? 'steer_bg_left_kuang'
                      : ''
                  "
                  class="steer_bg_kuang"
                  v-if="steerObj && steerObj.rightModelSteer && steerObj.rightbg"
                  :src="steerObj.rightbg"
                  alt=""
                  srcset=""
                />
                <div id="anchor" class="title" v-if="item.title">{{ item.title }}</div>
                <Record
                  :id="item.id"
                  :theme="item.theme"
                  :ref="'record' + item.id"
                  :statsVar="item.statsVar"
                  :richText="item.richText"
                  :noneInput="item.noneInput"
                  :bookTitle="item.bookTitle"
                  :statsNote="item.statsNote"
                  :recordNote="item.recordNote"
                  :text="item.richText ? text : ''"
                  :recordNoteEnd="item.recordNoteEnd"
                  :isShowAnswer="currentQSmall.showAnswer"
                  @getRecord="getRecord($event, item.type, itemIndex)"
                  :class="[item.classNmae, steerObj && steerObj.rightModelSteer ? 'steerBorder' : '']"
                >
                </Record>
              </template>
              <div v-if="item.type === 2" class="title">{{ item.title }}</div>
              <img v-if="item.type === 3" class="imgType" :src="item.img" :style="{ width: item.size }" alt="" />
              <VideoModule
                v-if="item.type === 11"
                :onlyId="'video' + currentQSmall.id + item.id"
                :hasVideoSlider="item.hasVideoSlider"
                :hasVideoButton="item.hasVideoButton"
                :videoArr="item.video"
                :key="itemIndex"
              ></VideoModule>
              <SingleClass
                v-if="item.type === 4"
                :config="item.config"
                :rightModelSteer="steerObj && steerObj.rightModelSteer"
                :isShowAnswer="currentQSmall.showAnswer"
                :value="item.value"
                :title="item.title"
                :submitList.sync="submitList"
              >
              </SingleClass>
              <div
                class="select"
                v-if="item.type === 5"
                :class="steerObj && steerObj.rightModelSteer ? 'steerBorder' : ''"
                data-stats-result="radio"
                :data-stats-topic="item.statsTopic"
              >
                <el-radio
                  class="selectRadio"
                  :label="index + 1"
                  v-model="item.answer"
                  v-for="(itemSon, index) of item.value"
                  :key="itemSon.type === 'text' ? itemSon.val : itemSon.label"
                  :data-click-stats="itemSon.clickStats"
                  :data-number="index + 1"
                >
                  <span>{{ itemSon.type === 'text' ? itemSon.val : itemSon.label }}</span>
                  <el-input
                    :class="item.answer === 5 ? 'selected_radio' : ''"
                    v-model="itemSon.val"
                    maxlength="20"
                    v-if="itemSon.type === 'input'"
                  ></el-input>
                </el-radio>
              </div>
              <div
                class="select"
                v-if="item.type === 6"
                :class="steerObj && steerObj.rightModelSteer ? 'steerBorder' : ''"
              >
                <img
                  class="steer_bg_kuang"
                  v-if="steerObj && steerObj.rightModelSteer && steerObj.rightbg"
                  :src="steerObj.rightbg"
                  alt=""
                  srcset=""
                />
                <el-checkbox-group
                  v-model="item.answerList"
                  data-stats-result="checkbox"
                  :data-stats-topic="item.statsTopic"
                  size="medium"
                >
                  <el-checkbox
                    v-for="(itemSon, indexSon) of item.value"
                    :label="typeof itemSon == 'string' ? itemSon : itemSon.val"
                    :key="itemSon.val"
                    :data-click-stats="itemSon.clickStats"
                    :data-number="indexSon + 1"
                  ></el-checkbox>
                </el-checkbox-group>
              </div>
              <Drag
                :isShowAnswer="currentQSmall.showAnswer"
                v-if="item.type == 7 || item.type == 9"
                :ref="'drag' + item.id"
                :item="item"
              />
              <div class="bubble" data-stats-result="bubble" @dragover.prevent v-if="item.type === 8">
                <img
                  v-if="steerObj && steerObj.rightModelSteer"
                  class="steer_bg_kuang"
                  :src="steerObj.rightbg"
                  alt=""
                  srcset=""
                />
                <div
                  class="bubble_list"
                  :key="typeIndex"
                  :class="
                    steerObj && steerObj.rightModelSteer && steerIndex !== 2 && typeIndex === 0 ? 'steerBorder' : ''
                  "
                  v-for="(type, typeIndex) of item.typeList"
                  :style="{
                    backgroundImage:
                      'url(' + require('./../../../../assets/exam/bj_' + ((typeIndex + 1) % 4) + '.png') + ')'
                  }"
                >
                  <i class="el-icon-error" v-if="!type.disabled" @click="bubbleTypeDel(typeIndex)" />
                  <div class="bubble_title">
                    <el-tooltip class="item" effect="dark" :content="type.title" placement="top-end">
                      <el-input
                        :disabled="type.disabled"
                        data-input-stats="input_VAR_txt#点击类别名称VAR录入名称"
                        :data-stats-var="typeIndex + 1"
                        v-model="type.title"
                        @change="bubbleTitleAdd($event, typeIndex)"
                        @paste.prevent
                        @dragover.prevent
                      />
                    </el-tooltip>
                  </div>
                  <div
                    class="bubble_answer"
                    @dragleave.prevent
                    @dragover.prevent
                    @dragleave="dragLeave(typeIndex)"
                    @dragover="dragEnter(typeIndex)"
                  >
                    <div class="bubble_answer_list">
                      <div
                        class="bubble_answer_list_input inputContent"
                        draggable="true"
                        :key="childIndex"
                        :style="{
                          top: child.top + 'px' || 0,
                          left: child.left + 'px' || 0,
                          position: child.position,
                          width: child.position === 'absolute' ? 'calc(100% -20px)' : '100%'
                        }"
                        @dragstart="dragstart(child.index, 'splice', $event)"
                        @dragend="dragend(childIndex, child.index, 'splice', typeIndex, $event)"
                        :data-stats-var="`${typeIndex + 1}-${child.index}`"
                        :data-index-var="child.index"
                        v-for="(child, childIndex) of type.children"
                      >
                        <!-- <span>{{ child.index + '.' }} </span> -->
                        <!-- <div
                          contenteditable="true"
                          @beforeinput="beforeInput"
                          @input="getRecord($event, 'bubble', typeIndex, child)"
                          data-input-stats="input_VAR1_VAR2_txt#作答区VAR1-VAR2-录入文字"
                          :data-stats-var="`${typeIndex + 1}#${child.index}`"
                          v-html="child.title"
                        ></div> -->
                        <my-editor
                          :ref="'my-editor-' + child.index"
                          :key="'my-editor-' + child.index"
                          @beforeinput="beforeInput"
                          @input="handlerInput"
                          data-input-stats="input_VAR1_VAR2_txt#作答区VAR1-VAR2-录入文字"
                          :data-stats-var="`${typeIndex + 1}#${child.index}`"
                          :serialNumber="child.index"
                          :lastAnswer="child.title"
                          :type="'drag_text'"
                          :autoresizeBottomMargin="0"
                        />
                      </div>
                    </div>
                    <div class="bubble_answer_input">
                      <div class="textInput" @click="addSubmitList(typeIndex)">
                        <div>文字录入</div>
                      </div>
                      <Record
                        :toHtml="true"
                        :type="'show'"
                        :richText="false"
                        :noneInput="true"
                        :submitList.sync="submitList"
                        @recordEnd="bubbleRecordEnd(typeIndex)"
                        :isShowAnswer="currentQSmall.showAnswer"
                        @getBubbleAnswer="getBubbleAnswer(typeIndex)"
                        @getRecord="getRecord($event, item.type, typeIndex)"
                        @getRecordContent="getRecordContent"
                        :class="typeIndex === 0 && steerObj && steerObj.imgbgModelSteer ? 'steerBorder' : ''"
                      ></Record>
                    </div>
                  </div>
                </div>
                <div
                  class="bubble_list"
                  @click="bubbleTypeAdd()"
                  v-if="!item.maxlength || item.typeList.length < item.maxlength"
                  style="cursor: pointer; background-size: 100% 100%"
                  :class="steerObj && steerObj.rightModelSteer && steerIndex === 2 ? 'steerBorder' : ''"
                >
                  <img
                    class="steer_bg_kuang"
                    v-if="steerObj && steerObj.id === '3-3'"
                    :src="require('@/assets/exam/kuang_right_chang.png')"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
              <div v-if="item.type === 10" class="draw_img_box">
                <img
                  v-if="steerObj && steerObj.rightModelSteer"
                  class="steer_bg_kuang"
                  :src="require('@/assets/exam/bj_kuang_yi.png')"
                  alt=""
                  srcset=""
                />
                <Draw
                  class="draw_img"
                  :class="steerObj && steerObj.rightModelSteer ? 'steerBorder' : ''"
                  :imgUrl="item.value === 'draw' ? item.drawImg[drawImgIndex].url : ''"
                  :drawImg="item.drawImg"
                  @getHistoryData="getHistoryData"
                  :ref="'draw' + item.id"
                />
                <div class="draw_img_button" v-if="item.value === 'draw'">
                  <div
                    v-for="(img, imgIndex) in item.drawImg"
                    :key="img.url"
                    :data-click-stats="img.clickStats"
                    @click="drawImgButton(imgIndex)"
                  >
                    <span :style="drawImgIndex === imgIndex ? 'color: #106172;' : 'color: #000;'">{{ img.name }}</span>
                    <span class="line" v-if="imgIndex !== item.drawImg.length - 1"></span>
                  </div>
                </div>
              </div>
              <!-- <Draw :title="item.title" @getHistoryData="getHistoryData" :tip="item.tip" v-if="item.type === 10" /> -->
              <Chart v-if="item.type === 12" :title="item.title" />
            </div>
          </template>
        </div>
      </div>
      <template v-if="currentQSmall.showAnswer">
        <div
          class="next"
          data-click-stats="done_task"
          @click="beforeGo('saveStepResult')"
          v-if="selectedQidSmall === lastQuestion && !$route.name.includes('Steer')"
        >
          作答完成
        </div>
        <div v-if="selectedQidSmall === lastQuestion && $route.name.includes('Steer')" class="next" @click="beforeGo">
          {{ !haveNextExam ? '测评完成' : !currentTheme ? '练习结束，接下来请完成一份调查问卷' : '开始正式测评' }}
        </div>
        <div
          class="next"
          data-click-stats="click_next"
          v-if="selectedQidSmall !== lastQuestion"
          @click="beforeGo('saveStepResult')"
        >
          下一题
        </div>
      </template>
      <template v-if="!currentQSmall.showAnswer && !currentTheme">
        <div class="title">看完视频后开始答题</div>
      </template>
    </div>
    <!-- 试卷作答结束页面 -->
    <div class="right end" :style="wChange && selectedQidSmall === 6 ? 'width: 55%' : ''" v-else>
      <div ref="answer">
        <div class="box">
          <img width="150px" height="150px" :src="themeList[currentTheme]['--main-end-img']" alt="" />
          <p class="answer_complete">作答完成</p>
          <template v-if="haveNextExam">
            {{ currentTheme ? '请继续作答问卷' : '请继续作答下一个任务' }}
          </template>
          <template v-else> 请继续作答问卷 </template>
          <!-- <div class="text" v-for="(item, index) in tabList" :key="index" >
            <img v-if="item.routerName.indexOf($route.name) > -1 && currentTheme" :src="item.img1" alt="">
            <img v-if="item.routerName.indexOf($route.name) > -1 && !currentTheme" :src="item.img0" alt="">
          </div> -->
        </div>
      </div>
      <div class="next" data-click-stats="next_task" v-if="haveNextExam" @click="beforeGo">
        {{ currentTheme ? '作答问卷' : '下一个任务' }}
      </div>
      <div class="next" v-else @click="beforeGo">{{ currentTheme ? '作答问卷' : '测评完成' }}</div>
    </div>
    <!-- 图片放大 -->
    <div
      class="imgBig"
      v-if="showBigImg"
      @click="showBigImg = false"
      data-click-stats="img_zoom_out"
      :data-image-kind="imgSrcKind"
    >
      <img :src="imgSrc" alt="" />
      <div class="icon">
        <img :src="require('@/assets/exam/icon_suoxiao.png')" alt="" />
      </div>
    </div>
    <!-- 引导 -->
    <ModelSteer
      ref="modelSteer"
      :qidList="qidList"
      :steerIndex.sync="steerIndex"
      :selectedQidSmall="selectedQidSmall"
      v-if="'examInnovationSteer, examCriticismSteer'.includes(this.$route.name)"
    />
    <!-- 批判题确认是否提交答案 -->
    <el-dialog :visible="modleVisible" center :append-to-body="true" width="30%" :before-close="() => modleVisible = false">
      <div class="text">{{ modleDescCriticism }}</div>
      <div class="text">你确定提交吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" data-click-stats="click_submit_button#确认提交"
          >确 认</el-button
        >
        <el-button @click="modleVisible = false" data-click-stats="click_cancel_submit_button#取消提交"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 创新题确认是否提交答案 -->
    <el-dialog :visible="modleVisibleInnovate" class="innovate" center :append-to-body="true" width="30%" :before-close="() => modleVisibleInnovate = false">
      <div class="text">{{ modleDescInnovate }}</div>
      <div class="text">你确定提交吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitInnovate">确 认</el-button>
        <el-button @click="modleVisibleInnovate = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Record from './record.vue'
import VideoModule from './video.vue'
import Drag from './drag.vue'
import SingleClass from './singleClass.vue'
import Draw from './draw.vue'
import Chart from './chart.vue'
import ModelSteer from './modelSteer.vue'
import ForewordEnergy from '../energy/foreword.vue'
import MyEditor from '@/component/Editor/Editor.vue'
import { htmlToFile } from '@/utils/index.js'
import { postProcessStats, saveStepResult } from '@/utils/stats'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Record,
    SingleClass,
    VideoModule,
    Drag,
    Draw,
    Chart,
    ModelSteer,
    ForewordEnergy,
    MyEditor
  },
  data() {
    return {
      steerIndex: 0,
      currentQSmall: {
        showAnswer: true,
        askList: [],
        currentQSmall: []
      },
      stemContent: [],
      time: '00:00',
      progress: 0,
      showPlay: true,
      bgColorArr: [require('./../../../../assets/exam/bj_1.png')],
      drawImgIndex: 0,
      examList: [],
      haveNextExam: true,
      tabList: [
        {
          id: 1,
          title: '任务A',
          routerName: 'examCosmodom,examPhone',
          name0: '中国空间站的科学实验',
          name1: '',
          img0: require('@/assets/exam/theme0/zi_1.png'),
          img1: require('@/assets/exam/theme1/zi_1.png')
        },
        {
          id: 2,
          title: '任务B',
          name0: '禽流感的防控',
          name1: '',
          routerName: 'examBirdFlu,examPepper',
          img0: require('@/assets/exam/theme0/zi_2.png'),
          img1: require('@/assets/exam/theme1/zi_2.png')
        },
        {
          id: 3,
          title: '任务C',
          name0: '未来的遥控器',
          name1: '',
          routerName: 'examController,examDuJiangYan',
          img0: require('@/assets/exam/theme0/zi_3.png'),
          img1: require('@/assets/exam/theme1/zi_3.png')
        },
        {
          id: 4,
          title: '任务D',
          name0: '校园里的雨水收集',
          name1: '',
          routerName: 'examStormwater,examChiliProblem',
          img0: require('@/assets/exam/theme0/zi_4.png'),
          img1: require('@/assets/exam/theme1/zi_4.png')
        },
        {
          id: 5,
          title: '任务E',
          name0: '芽苗菜的培养',
          name1: '',
          routerName: 'examSprout,examEnergy',
          img0: require('@/assets/exam/theme0/zi_5.png'),
          img1: require('@/assets/exam/theme1/zi_5.png')
        }
      ],
      themeList: [
        {
          '--button-bg-color': '#4F6A5A',
          '--task-bg-color': '#4F6A5A',
          '--task-font-color': '#88A0B1',
          '--title-bg-img': require('@/assets/exam/theme0/renwu_yao@2x.png'),
          // 创新试卷任务栏的样式
          '--tab-font-color': '#106172',
          '--tab-bg-color': '#F8F5ED',
          '--tab-border-color': '#C2C5A5',
          '--tab-bg-img': 'url(' + require('@/assets/exam/theme0/bj_oweixuan.png') + ')',
          '--tab-top-bg-img': 'url(' + require('@/assets/exam/theme0/bj_tweixuan.png') + ')',
          '--tab-active-bg-img': 'url(' + require('@/assets/exam/theme0/bj_oxuanzhong.png') + ')',
          '--tab-active-top-bg-img': 'url(' + require('@/assets/exam/theme0/bj_txuanzhong.png') + ')',
          // 答题结束样式
          '--main-end-img': require('@/assets/exam/theme0/icon_wancheng.png'),
          '--main-end-title': require('@/assets/exam/theme0/wancheng.png'),
          '--main-left-bg': 'url(' + require('@/assets/exam/theme0/1.png') + ')',
          '--main-left-content-bg': 'url(' + require('@/assets/exam/theme0/z_k@2x.png') + ')',
          '--main-right-title': require('@/assets/exam/theme0/w_zd@2x.png'),
          '--main-right-next-btn': 'url(' + require('@/assets/exam/theme0/bj_xia_zi@2x.png') + ')',
          '--main-dialog-bg': 'url(' + require('@/assets/exam/theme0/dialog_bg.png') + ')',
          '--main-right-content-bg': 'url(' + require('@/assets/exam/theme0/bj_zuoda_yao@2x.png') + ')',
        },
        {
          '--button-bg-color': '#5B4069',
          '--task-bg-color': '#5E2E56',
          '--task-font-color': '#9F9F9F',
          '--title-bg-img': require('@/assets/exam/theme1/renwu_yao@2x.png'),
          '--tab-font-color': '#484367',
          '--tab-bg-color': '#E2DBEA',
          '--tab-border-color': '#B59DC3',
          '--task-answer-bg-color': '#EAE3F4',
          '--task-answer-font-color': '#81688D',
          '--tab-bg-img': 'url(' + require('@/assets/exam/theme1/bj_oweixuan.png') + ')',
          '--tab-top-bg-img': 'url(' + require('@/assets/exam/theme1/bj_tweixuan.png') + ')',
          '--tab-active-bg-img': 'url(' + require('@/assets/exam/theme1/bj_oxuanzhong.png') + ')',
          '--tab-active-top-bg-img': 'url(' + require('@/assets/exam/theme1/bj_txuanzhong.png') + ')',
          // 答题结束样式
          '--main-end-img': require('@/assets/exam/theme1/icon_wancheng.png'),
          '--main-end-title': require('@/assets/exam/theme1/wancheng.png'),
          '--main-left-bg': 'url(' + require('@/assets/exam/theme1/1.png') + ')',
          '--main-left-content-bg': 'url(' + require('@/assets/exam/theme1/z_k@2x.png') + ')',
          '--main-right-title': require('@/assets/exam/theme1/2.png'),
          '--main-right-next-btn': 'url(' + require('@/assets/exam/theme1/bj_xia_zi@2x.png') + ')',
          '--main-dialog-bg': 'url(' + require('@/assets/exam/theme1/dialog_bg.png') + ')',
          '--main-right-content-bg': 'url(' + require('@/assets/exam/theme1/bj_zuoda_yao@2x.png') + ')',
        }
      ],
      currentTheme: 0,
      radio: -1,
      dragList: [],
      lastQuestion: 1,
      showBigImg: false,
      submitList: [],
      isEnter: false,
      pargentIndex: 0,
      index: 0,
      typeIndex: 0,
      typeSonIndex: 0,
      showOperation: false,
      operationLeft: 0,
      operationTop: 0,
      currentIndex: 0,
      modleVisible: false,
      modleDescCriticism: '',
      imgSrc: '',
      imgSrcKind: '',
      textArrLength: null,
      isSure: false,
      text: '',
      videoUrl: '',
      schoolDot: null,
      historyData: [],
      startclientX: 0,
      startclientY: 0,
      modleVisibleInnovate: false,
      modleDescInnovate: '',
      statsTopic: '',
      saveStepResultFlag: true
    }
  },
  computed: {
    ...mapState(
      {
        editorConetnt: state => state.editorConetnt
      }
    ),
    steerObj() {
      return 'examInnovationSteer, examCriticismSteer'.includes(this.$route.name)
        ? this.$refs.modelSteer.steerObj
        : null
    },
    getLeftWidth() {
      const type =
        (!'examInnovationSteer, examCriticismSteer'.includes(this.$route.name) &&
          !this.currentTheme &&
          this.selectedQidSmall == 2) ||
        (this.$route.name === 'examInnovationSteer' && this.selectedQidSmall === 3)
      return this.currentQSmall.contentWidth ? 'width:' + this.currentQSmall.contentWidth : type ? 'width: 30%;' : ''
    },
    getRightWidth() {
      const type1 = this.wChange && this.selectedQidSmall === 6
      const type2 =
        ((!this.$refs.modelSteer || !this.$refs.modelSteer.steerObj) &&
          !this.currentTheme &&
          this.selectedQidSmall === 2) ||
        (this.$route.name === 'examInnovationSteer' && this.selectedQidSmall === 3)
      return this.currentQSmall.askWidth
        ? 'width: ' + this.currentQSmall.askWidth
        : type1
        ? 'width: 55%; display: inlin-block'
        : type2
        ? 'width: 70%'
        : ''
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isEnd: {
      type: Boolean,
      default: false
    },
    qidList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedQidSmall: {
      type: Number,
      default: 1
    },
    wChange: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.tabList.forEach(item => {
      if (item.routerName.indexOf(this.$route.name) > -1) {
        item.active = true
      } else {
        item.active = false
      }
    })
    this.init()
  },
  methods: {
    ...mapMutations(['setEditorConetnt', 'clearEditorConetnt']),
    getHistoryData(el) {
      this.historyData = el
    },
    beforeInput() {
      console.log('beforeInput =======>')
      setTimeout(() => {
        document.execCommand('ForeColor', false, '#FE5C2B')
        document.execCommand('FontSize', false, 3)
      }, 0)
    },
    addSubmitList(index) {
      if (this.steerObj) return
      const obj = {
        title: '',
        index: this.submitList.length + 1
      }
      this.submitList.push({
        title: '',
        isMove: true,
        index: this.submitList.length + 1
      })
      this.currentQSmall.askList[0].typeList[index].children.push(obj)
      postProcessStats({
        event: `click_${index + 1}_txtbutton`,
        note: `点击文字录入按钮${index + 1}`
      })
    },
    bubbleTitleAdd(val, index) {
      this.currentQSmall.askList[0].typeList[index].title = val
      this.$forceUpdate()
    },
    bubbleTypeDel(index) {
      this.$confirm('请确认是否删除此分类？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        confirmButtonClass: 'confrim_button',
        cancelButtonClass: 'cel_utton'
      })
        .then(() => {
          this.currentQSmall.askList[0].typeList.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          postProcessStats({
            event: `click_${index + 1}_del`,
            note: `点击删除类别${index + 1}`
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      // this.modleVisible = true
      // this.modleDesc = '请确认是否删除此分类？'
    },
    bubbleTypeAdd() {
      this.currentQSmall.askList[0].typeList.push({
        title: '',
        children: []
      })
      const count = this.currentQSmall.askList[0].typeList.length
      postProcessStats({
        event: `click_${count}_add`,
        note: `点击新增类别${count}`
      })
    },
    showSchool(type) {
      this.showBigImg = !this.showBigImg
      this.videoUrl = ''
      this.schoolDot = null
      const className = this.$refs.stormwater[0].className
      this.$refs.stormwater[0].className = 'list stormwater'
      if (className === 'list') {
        if (type !== 'stormwater') return
        console.log(this.currentQSmall.stemContent)
        this.currentQSmall.stemContent[1].imgArr.forEach(item => {
          if ('体育馆, 田径场'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) + 10 + '%'
            item.y = Number(item.y.split('%')[0]) + 3 + '%'
          } else if ('学生公寓'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) - 3 + '%'
            item.y = Number(item.y.split('%')[0]) + 2.5 + '%'
          } else if ('绿地'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) + 3 + '%'
            item.y = Number(item.y.split('%')[0]) + 3.5 + '%'
          } else if ('道路'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) - 6 + '%'
            item.y = Number(item.y.split('%')[0]) + 3.5 + '%'
          } else if ('教学楼1, 篮球场'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) - 11 + '%'
            item.y = Number(item.y.split('%')[0]) + 2 + '%'
          } else if (item.name === '教学楼2') {
            item.x = Number(item.x.split('%')[0]) - 15 + '%'
            item.y = Number(item.y.split('%')[0]) + 2 + '%'
          } else if (item.name === '花坛') {
            item.x = Number(item.x.split('%')[0]) + 15.5 + '%'
            item.y = Number(item.y.split('%')[0]) + 3 + '%'
          }
        })
      } else {
        this.$refs.stormwater[0].className = 'list'
        if (type !== 'stormwater') return
        this.currentQSmall.stemContent[1].imgArr.forEach(item => {
          if ('体育馆, 田径场'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) - 10 + '%'
            item.y = Number(item.y.split('%')[0]) - 3 + '%'
          } else if ('学生公寓'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) + 3 + '%'
            item.y = Number(item.y.split('%')[0]) - 2.5 + '%'
          } else if ('绿地'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) - 3 + '%'
            item.y = Number(item.y.split('%')[0]) - 3.5 + '%'
          } else if ('道路'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) + 6 + '%'
            item.y = Number(item.y.split('%')[0]) - 3.5 + '%'
          } else if ('教学楼1, 篮球场'.includes(item.name)) {
            item.x = Number(item.x.split('%')[0]) + 11 + '%'
            item.y = Number(item.y.split('%')[0]) - 2 + '%'
          } else if (item.name === '教学楼2') {
            item.x = Number(item.x.split('%')[0]) + 15 + '%'
            item.y = Number(item.y.split('%')[0]) - 2 + '%'
          } else if (item.name === '花坛') {
            item.x = Number(item.x.split('%')[0]) - 15.5 + '%'
            item.y = Number(item.y.split('%')[0]) - 3 + '%'
          }
        })
      }
    },
    schoolClick(index, arr, type, dot) {
      if (type === 'stormwater') {
        this.videoUrl = arr[index].videoUrl
        this.schoolDot = dot
      } else {
        this.currentQSmall.stemContent.forEach(item => {
          if (item.imgArr && item.imgArr.length > 0) {
            item.imgArr.forEach((item, idex) => {
              if (index === idex) {
                item.isShow = !item.isShow
              } else {
                item.isShow = false
              }
            })
          }
        })
        this.$forceUpdate()
      }
    },
    fullscreenchange(ev) {
      const isFullscreen = document.fullscreenElement == ev.target
      const event = this.schoolDot.statsName + (isFullscreen ? '_fullscreen' : '_cancel_fullscreen')
      const note = `点击${this.schoolDot.name}视频${isFullscreen ? '放大' : '缩小'}按钮`
      postProcessStats({ event, note })
    },
    schoolVideoClose() {
      this.videoUrl = ''
      this.schoolDot = null
    },
    drawImgButton(index) {
      this.drawImgIndex = index
    },
    textShow(index) {
      this.currentQSmall.stemContent[index].down = !this.currentQSmall.stemContent[index].down
      this.$forceUpdate()
      const item = this.currentQSmall.stemContent[index]
      const label = item.label || ''
      const matches = label.match(/\d+|一|二|三|四|五|六|七|八|九/)
      const num = matches ? matches[0] : ''
      const down = item.down
      if (num) {
        postProcessStats({
          event: `${down ? 'unfold' : 'fold'}_material_${num}`,
          note: `${down ? '展开' : '折叠'}${label}`
        })
      }
    },
    showImg(item) {
      if (item.showBigImg || (this.currentTheme && !item.isBig)) {
        this.showBigImg = item.showBigImg || true
        if (this.$route.name === 'examPepper' && (this.selectedQidSmall === 5 || this.selectedQidSmall === 6)) {
          this.imgSrc = require('@/assets/exam/28_big.png')
          this.imgSrcKind = item.imageKind
        } else {
          this.imgSrc = item.img || item.value
          this.imgSrcKind = item.imageKind
        }
      } else {
        this.showBigImg = false
      }
    },
    init() {
      this.videoArr = []
      this.steerIndex = 0
      this.qidList.find(item => {
        item.small.forEach(itemSon => {
          if (itemSon.id === this.selectedQidSmall) {
            itemSon.active = true
            if (itemSon.showAnswer === undefined) {
              itemSon.showAnswer = true // 默认为true。目前只有视频播放完和答案的显示有强绑定
            }
            if ('examInnovationSteer, examCriticismSteer'.includes(this.$route.name)) {
              this.currentQSmall = { ...itemSon }
            } else {
              this.currentQSmall = { ...itemSon }
            }
            const arr = []
            // 批判试卷对资料数量大于3的任务清单进行处理
            // 对当前题目不同资源进行处理
            this.currentQSmall.stemContent.find(item => {
              if (item.type === 'video') {
                this.videoArr.push({ id: 'video' + this.currentQSmall.id + item.id, end: false })
              }
              if (item.type === 'textArray') {
                if (arr.length === 0) item.down = true
                arr.push(item)
                item.value.forEach(it => {
                  if (it.type === 'video') {
                    this.videoArr.push({ id: 'video' + this.currentQSmall.id + it.id, end: false })
                  }
                })
              }
              if (item.type === 'stormwater') {
                this.schoolImg = item.img
              }
            })
            this.textArrLength = arr.length
          } else {
            itemSon.active = false
          }
          this.lastQuestion = itemSon.id
        })
      })
      // 计算倒计时
      this.initTime()
      this.initTheme()
      this.initExamList()
      this.initCategory()
      this.radio = -1
      const selectedQidSmall = sessionStorage.getItem('selectedQidSmall')
      if (selectedQidSmall) {
        this.$parent.selectedQidSmall = Number(selectedQidSmall)
      }
      this.updateStatsCommon()
      this.clearEditorConetnt()
    },
    updateStatsCommon() {
      const exam = this.examList.find(item => item.active)
      const letter = exam ? exam.title.replace('任务', '') : ''
      console.log('💢💢💢 updateStatsCommon', this.examList, this.qidList)
      const sub = this.selectedQidSmall
      let topic = `${letter}-${sub}`

      // 创新题的 topic 形式为 A-1-1
      if (this.$route.meta.innovation) {
        const number = this.qidList.findIndex(item => item.small.some(sub => sub.active)) + 1
        topic = `${letter}-${number}-${sub}`
      }

      // 若明确提供了 number，则按照提供的 number 来，主要是为了应对匹配任务 A 中（2、3题）组合在一起的特殊情况
      // 创新题是大小分类的，应该不会出现多题混合的情况，如果真出现了，再来调整下面的代码。
      const small = this.findActiveSmall()
      if (small && small.topicNumber) {
        topic = `${letter}-${small.topicNumber}`
      }

      this.statsTopic = topic
      sessionStorage.setItem('statsCurrentTopic', topic)
      postProcessStats({ topic, event: 'enter_page' })
    },
    findActiveSmall() {
      for (const item of this.qidList) {
        for (const sub of item.small) {
          if (sub.active) {
            return sub
          }
        }
      }
    },
    initTheme() {
      const subjectPath = this.$route.fullPath
      const theme0 = ['innovation', 'controller', 'stormwater', 'cosmodom', 'birdFlu', 'sprout']
      if (theme0.findIndex(item => subjectPath.indexOf(item) > -1) > -1) {
        this.changeTheme(this.themeList[0])
        this.currentTheme = 0
      } else {
        this.changeTheme(this.themeList[1])
        this.currentTheme = 1
      }
    },
    /**
     * category 值：创新任务  1  批判任务 2  创新学生问卷 3 创新老师问卷 4
     */
    initCategory() {
      if (this.currentTheme) {
        sessionStorage.setItem('examCategory', 2)
      } else {
        sessionStorage.setItem('examCategory', 1)
      }
    },
    initTime() {
      this.time = '00:00'
      this.progress = 0
      const allTime = this.currentQSmall.durationTime * 60
      let overTime = allTime
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (overTime === 0) {
          clearInterval(this.timer)
          this.beforeGo()
          return
        }
        overTime--
        const remainingTime = allTime - overTime
        const repair1 = Math.floor(remainingTime / 60) <= 9 ? '0' : ''
        const repair2 = remainingTime % 60 <= 9 ? '0' : ''
        this.time = repair1 + Math.floor(remainingTime / 60) + ':' + repair2 + (remainingTime % 60)
        const result = (remainingTime / allTime) * 100
        this.progress = result + '%'
        // if (this.$route.name === 'examStormwater' && this.selectedQidSmall === 1 && this.currentQSmall.showAnswer) {
        //   if (result >= 20 && result < 21) {
        //     this.tipMessage = '再想出一个 ！'
        //   } else if (result >= 30 && result < 31) {
        //     this.tipMessage = '加油 ！'
        //   } else {
        //     this.tipMessage = ''
        //   }
        // } else {
        //   this.tipMessage = ''
        // }
      }, 1000)
    },
    // 初始化试卷列表
    initExamList() {
      const examMap = [
        {
          name: 'examPhone',
          title: '任务A'
        },
        {
          name: 'examPepper',
          title: '任务B'
        },
        {
          name: 'examDuJiangYan',
          title: '任务C'
        },
        {
          name: 'examChiliProblem',
          title: '任务D'
        },
        {
          name: 'examEnergy',
          title: '任务E'
        },
        {
          name: 'examCosmodom',
          title: '任务A'
        },
        {
          name: 'examBirdFlu',
          title: '任务B'
        },
        {
          name: 'examController',
          title: '任务C'
        },
        {
          name: 'examStormwater',
          title: '任务D'
        },
        {
          name: 'examSprout',
          title: '任务E'
        }
      ]
      this.examList = []
      // 筛选出那十套试卷
      JSON.parse(sessionStorage.currentExamGroup).exam.forEach(item => {
        const examMapItem = examMap.find(itemMap => itemMap.name === item)
        if (examMap.findIndex(itemMap => itemMap.name === item) > -1) {
          this.examList.push({
            id: new Date().getTime() + '_' + examMapItem.title,
            title: examMapItem.title,
            active: this.$route.name === item,
            isFirst: JSON.parse(sessionStorage.currentExamGroup).firstExam === item
          })
        }
      })
      if (JSON.parse(sessionStorage.currentExamGroup).exam.length == 1) {
        this.haveNextExam = false
        return
      }
      // 判断是否有下一试卷
      if (JSON.parse(sessionStorage.currentExamGroup).id < 7) {
        this.haveNextExam = false
      } else {
        if (JSON.parse(sessionStorage.currentExamGroup).exam.length - 2 == sessionStorage.currentExamIndex) {
          this.haveNextExam = false
        } else {
          this.haveNextExam = true
        }
      }
    },
    videoEnd(id) {
      let videoId
      let videoEnd = false
      if (!this.currentQSmall.showAnswer) {
        this.initTime()
      }
      this.videoArr.forEach(item => {
        if (item.id === id) item.end = true
        if (!item.end) videoId = item.id
        videoEnd = item.end
      })
      this.currentQSmall.showAnswer = videoEnd
      if (!videoEnd) this.$refs[videoId][0].play()
    },
    getBubbleAnswer(index) {
      this.currentQSmall.askList[0].typeList[index].children.push({
        title: '',
        index: this.submitList.length
      })
    },
    bubbleRecordEnd(typeIndex) {
      const children = this.currentQSmall.askList[0].typeList[typeIndex].children
      const count = children.length
      if (count > 0) {
        const newItem = children[count - 1]
        postProcessStats({
          event: `clickinput_${typeIndex + 1}_${newItem.index}_audio`,
          note: `点击语音录入按钮-作答区${typeIndex + 1}-${newItem.index}录入语音`
        })
      }
    },
    getRecord(obj, type, index, child) {
      if (type === 8) {
        if (!this.currentQSmall.askList[0].typeList[index].title) {
          this.$message.error('请先为你增加的类别命名!')
          return
        }
        const childLength = this.currentQSmall.askList[0].typeList[index].children.length
        this.currentQSmall.askList[0].typeList[index].children[childLength - 1].title =
          '<font color="#fe5c2b">' + obj.value + '</font>'
      } else if (type === 'bubble') {
        this.submitList.forEach(item => {
          if (item.index === child.index) {
            item.title = obj.target.innerHTML
          }
        })
      } else {
        this.currentQSmall.askList[index].answer = obj.value
      }
      this.$forceUpdate()
    },
    beforeGo(stepAction) {
      if (typeof stepAction !== 'string') {
        this.saveStepResultFlag = false
      }
      this.currentQSmall.askList.forEach((item, index) => {
        // 辣椒试卷第七题调查方案回显在第八题并可编辑并修改字体颜色
        if (item.isReview) {
          if (!('examPepper, examChiliProblem, examDuJiangYan, examCriticismSteer'.includes(this.$route.name))) {
            this.$emit('getAnswer', {
              index: index,
              text: item.answer,
              selectedQidSmall: this.selectedQidSmall
            })
          } else {
            this.text = item.answer
          }
        }
      })
      if (!this.isEnd) {
        // console.log(this.currentQSmall.askList)
        let lock = false
        this.currentQSmall.askList.forEach(item => {
          if (lock === true) return
          if (item.type === 4 && this.submitList.length === 0) {
            this.modleDescInnovate = '本题未输入答案提交后不可更改'
            this.modleDescCriticism = '本题未输入答案提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 8 && item.typeList.findIndex(typeItem => typeItem.children.length > 0) === -1) {
            this.modleDescInnovate = '本题未将想法进行分类本题未选择选项提交后不可更改'
            this.modleDescCriticism = '本题未将想法进行分类本题未选择选项提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 1 && !this.$refs['record' + item.id][0].record) {
            this.modleDescInnovate = '本题未输入答案提交后不可更改'
            this.modleDescCriticism = '本题未输入答案提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 5 && !item.answer) {
            this.modleDescInnovate = '本题未选择选项提交后不可更改'
            this.modleDescCriticism = '本题未选择选项提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 6 && item.answerList.length === 0) {
            this.modleDescCriticism = '本题未选择选项提交后不可更改'
            this.modleDescCriticism = '本题未选择选项提交后不可更改'
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 9 && !this.$refs['drag' + item.id][0].start) {
            this.modleDescInnovate = '本题未拖拽提交后不可更改'
            this.modleDescCriticism = '本题未拖拽提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          } else if (item.type === 10 && this.$refs['draw' + item.id][0].isCanvasBlank()) {
            this.modleDescInnovate = '本题未作图提交后不可更改'
            this.modleDescCriticism = '本题未作图提交后不可更改'
            this.modleVisibleInnovate = !this.currentTheme
            this.modleVisible = !!this.currentTheme
            lock = true
          }
        })
        if (!lock) {
          if (this.currentTheme) {
            this.modleDescCriticism = '本题提交后不可更改'
            this.modleVisible = true
          } else {
            this.go()
          }
        }
      } else {
        this.go()
      }
    },
    handleSubmit() {
      const answerList = this.$store.getters.answerList || []
      this.modleVisible = false
      const isExit = answerList.findIndex((it, index) => {
        if (it === this.selectedQidSmall) {
          return index
        }
      })
      if (isExit === -1) {
        answerList.push(this.selectedQidSmall)
      }
      if (this.currentTheme) {
        this.$store.commit('setAnswerList', answerList)
      }
      this.go()
    },
    handleSubmitInnovate() {
      const answerList = this.$store.getters.answerList || []
      this.modleVisibleInnovate = false
      const isExit = answerList.findIndex((it, index) => {
        if (it === this.selectedQidSmall) {
          return index
        }
      })
      if (isExit === -1) {
        answerList.push(this.selectedQidSmall)
      }
      if (this.currentTheme) {
        this.$store.commit('setAnswerList', answerList)
      }
      this.go()
    },
    goPage(id) {
      if (id > this.selectedQidSmall) {
        this.$message({
          message: '不可跳转',
          type: 'warning'
        })
      } else if (this.currentTheme) {
        let obj
        const arr = [...this.qidList]
        arr.forEach(item => {
          item.small.forEach(itemSon => {
            if (itemSon.id === id) {
              itemSon.active = true
              if (itemSon.showAnswer === undefined) {
                itemSon.showAnswer = true // 默认为true。目前只有视频播放完和答案的显示有强绑定
              }
              obj = itemSon.stemContent
              this.currentQSmall = Object.assign(this.currentQSmall, {
                contentWidth: itemSon.contentWidth,
                askWidth: itemSon.askWidth
              })
              const arr = []
              obj.find(item => {
                if (item.type === 'textArray') {
                  if (arr.length === 0) item.down = true
                  arr.push(item)
                }
              })
              this.textArrLength = arr.length
              postProcessStats({
                event: 'look_back_topic_' + id + '_at_' + this.selectedQidSmall,
                note: this.selectedQidSmall + '回看题目' + id
              })
            } else {
              itemSon.active = false
            }
          })
        })
        this.currentQSmall = Object.assign(this.currentQSmall, {
          stemContent: obj
        })
      }
    },
    go(type) {
      const topicType = this.currentQSmall.askList.length > 0 ? this.currentQSmall.askList[0].type : ''
      const richText = this.currentQSmall.askList.length > 0 ? this.currentQSmall.askList[0].richText : ''

      if (this.loading) return
      if (this.selectedQidSmall === 0) {
        this.$parent.next({}, this.selectedQidSmall, type)
        return
      }
      // 提测记得还原这块
      if (sessionStorage.userInfo) {
        const userInfo = JSON.parse(sessionStorage.userInfo || '{}')
        this.$emit('update:loading', true)
        document.getElementsByClassName('right')[0].scrollTop = 0
        this.replaceContent(topicType, richText)
        // 替换完文本，保存答案
        if (this.saveStepResultFlag) saveStepResult()
        setTimeout(() => {
          htmlToFile(this.$refs.answer, file => {
            sessionStorage.removeItem('selectedQidSmall')
            this.$parent.next(
              {
                stu_num: userInfo.stu_num,
                exam_file: file
              },
              this.selectedQidSmall,
              type
            )
          })
        }, 1000)
      } else {
        this.$message({
          message: '请登录后再答题！',
          type: 'error'
        })
      }
    },
    changeTheme(theme) {
      for (const key in theme) {
        if (Object.hasOwnProperty.call(theme, key)) {
          const element = theme[key]
          document.documentElement.style.setProperty(key, element)
        }
      }
    },
    dragstart(index, type, el) {
      this.index = index - 1
      if (type === 'push' && this.submitList[index - 1].isMove) return
      if (type === 'splice') {
        this.startclientX = el.clientX // 记录拖拽元素初始位置
        this.startclientY = el.clientY
        const parentBox = document.getElementsByClassName('bubble_answer_list')
        for (let m = 0; m < parentBox.length; m++) {
          for (let n = 0; n < parentBox[m].children.length; n++) {
            this.submitList.forEach(answer => {
              if (this.currentQSmall.askList[0].typeList[m].children[n].index === answer.index) {
                this.currentQSmall.askList[0].typeList[m].children[n].title = answer.title
              }
            })
          }
        }
      }

      // 统计拖动
      const target = el.target
      if (target && target.dataset && 'statsVar' in target.dataset) {
        const statsVar = target.dataset.statsVar
        const [pos, num] = statsVar.split('-')
        postProcessStats({
          event: `clickkeep_${pos}${num}`,
          note: `按住位置${statsVar}`
        })
      }
    },
    dragend(childIndex, index, type, parentIndex, el, childNode) {
      if (type === 'push' && this.submitList[this.index].isMove) return
      if (this.isEnter) {
        if (!this.currentQSmall.askList[0].typeList[this.typeIndex].title) {
          this.$message.error('请先为你增加的类别命名!')
          return
        }
        if (type === 'splice') {
          this.currentQSmall.askList[0].typeList[parentIndex].children.forEach((item, idex) => {
            if (item.index === index) {
              console.log('item ----->', idex, item);
              this.currentQSmall.askList[0].typeList[this.typeIndex].children.push(item)
              this.currentQSmall.askList[0].typeList[parentIndex].children.splice(idex, 1)
              postProcessStats({
                event: `clickoff_${this.typeIndex + 1}${index}`,
                note: `放置位置${this.typeIndex + 1}-${index}`
              })
            }
          })
          this.submitList.forEach((item, inx) => {
            if (this.$refs['my-editor-' + item.index]) {
              this.$refs['my-editor-' + item.index].forEach(editor => {
                this.$nextTick(() => {
                  editor.initEditor()
                })
              })
            }
          })
        } else {
          this.currentQSmall.askList[0].typeList[this.typeIndex].children.push({
            title: this.submitList[this.index].title,
            index: this.submitList[this.index].index
          })
          this.submitList[this.index].isMove = true
          this.isEnter = false
          postProcessStats({
            event: `clickoff_${this.typeIndex + 1}${this.index + 1}`,
            note: `放置位置${this.typeIndex + 1}-${this.index + 1}`
          })
        }
      } else {
        if (type === 'splice') {
          this.submitList.forEach(item => {
            if (item.index === index) {
              item.isMove = false
            }
          })
          this.currentQSmall.askList[0].typeList[parentIndex].children.forEach((item, idex) => {
            if (item.index === index) {
              this.currentQSmall.askList[0].typeList[parentIndex].children.splice(idex, 1)
              postProcessStats({
                event: `clickoff_0${item.index}`,
                note: `放置位置0-${item.index}`
              })
            }
          })
          this.submitList.forEach((item, inx) => {
            if (this.$refs['my-editor-' + item.index]) {
              this.$refs['my-editor-' + item.index].forEach(editor => {
                this.$nextTick(() => {
                  editor.initEditor()
                })
              })
            }
          })
        }
      }
    },
    dragEnter(index) {
      this.isEnter = true
      this.typeIndex = index
    },
    dragLeave() {
      this.isEnter = false
    },
    changeTitle(e, type, index) {
      this.currentQSmall.askList.forEach(item => {
        if (item.type === 8 && item.typeList) {
          item.typeList[index].title = e.target.value
        }
      })
    },
    addAnswer(index) {
      this.currentQSmall.askList.forEach(item => {
        if (item.type === 8) {
          item.typeList[index].children.push({})
        }
      })
    },
    deleteAnswer(index, indexSon) {
      this.currentQSmall.askList.forEach(item => {
        if (item.type === 8) {
          item.typeList[index].children.splice(indexSon, 1)
        }
      })
    },
    handlerInput(value, index) {
      // 缓存输入内容
      this.setEditorConetnt({ index, value })
      // 去除索引内容
      // const regex = /<span[^>]*>(\d+\.\s*)<\/span>|<span[^>]*>(\d+)\.\s*(\d+)(<\/span>)/
      const regex = /\d+\.\s*/
      this.submitList.splice(index, 1, { title: value.replace(regex, '').replace(/<p>/g, '<span style="color: #ff0000;">').replace(/<\/p>/g, '</span>'), index: index + 1, isMove: true })
      this.$forceUpdate()
    },
    // 为了解决富文本编辑器内容无法获取的问题，暂时使用这个方法
    replaceContent (type, richText) {
      const contentNodes = document.querySelectorAll('.inputContent')

      contentNodes.forEach((item, index) => {
        const domIndex = item.getAttribute('data-index-var') || null
        const content = document.createElement('div')
        content.setAttribute('class', 'replaceContent')
        content.setAttribute('data-contenteditable', 'true');
        content.style.fontSize = '16px'
        content.style.marginBottom = type === 8 || type === 4 ? '0px' : '50px'
        content.style.display = type === 8 || type === 4 ? 'flex' : 'block'
        content.style.color = type === 8 || (type === 1 && richText) ? '#ff0000' : '#383838'
        content.innerHTML = type === 8 || type === 4 ? `<span style='color: #000; width: 35px'>${domIndex || (index + 1)}. </span>${this.editorConetnt[domIndex ? domIndex - 1 : index]}` : this.editorConetnt[domIndex ? domIndex - 1 : index] || ''
        const paragraphs = content.querySelectorAll('p')
        paragraphs.forEach(paragraph => {
          paragraph.style.width = '100%';
        });
        item.innerHTML = ''
        item.appendChild(content)
      })
    },
    getRecordContent(val) {
      const index = this.submitList.length
      this.$refs['my-editor-' + index][0].setRecord(val)
    }
  },
  watch: {
    selectedQidSmall() {
      this.init()
      // },
      // historyData() {
      //   console.log(this.historyData)
    },
    '$store.state.minute': {
      handler(el) {
        const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
        if (examArr.length === 1) {
          if (el == 30 && sessionStorage.subjectName === 'innovationSteer') {
            this.go('overTime')
          } else if (el == 90) {
            this.go('overTime')
          }
        } else if (el == 90) {
          this.go('overTime')
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.mainContent {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 55%;
    background-image: var(--main-left-bg);
    background-size: 100% 100%;
    padding: 35px 1% 4% 1%;
    overflow-y: auto;
    .stem.pipan {
      width: calc(53vw - 30px);
    }
    .stem {
      width: 100%;
      padding-left: 107px;
      position: relative;
      .tab {
        width: 30px;
        position: absolute;
        top: 81px;
        left: 0px;
        overflow: hidden;
        .tag {
          width: 100%;
          height: 110px;
          font-size: 14px;
          font-weight: 500;
          padding: 0 0.05633rem 0.04333rem;
          display: flex;
          color: #fff;
          flex-direction: column;
          justify-content: center;
          text-align: center;
          margin-bottom: -18px;
          background-image: var(--tab-bg-img);
          background-size: 100% 100%;
          position: relative;
        }
        .tag.top {
          background-image: var(--tab-top-bg-img);
          background-size: 100% 100%;
          position: relative;
        }
        .tag.otabActive {
          color: var(--tab-font-color);
          background-image: var(--tab-active-bg-img);
          background-size: 100% 100%;
        }
        .tag.top.ttabActive {
          z-index: 5;
          color: var(--tab-font-color);
          background-image: var(--tab-active-top-bg-img);
          background-size: 100% 100%;
        }
        img {
          width: 30px;
        }
      }
      .step {
        width: 60px;
        min-height: 6.35333rem;
        background: var(--tab-bg-color);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border: 1px solid var(--tab-border-color);
        position: absolute;
        top: 81px;
        left: 30px;
        overflow: hidden;
        .task {
          border-top: 1px solid rgba(122, 157, 179, 0.3);
          &:nth-child(1) {
            border-top: none;
          }
          > div {
            width: 100%;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .taskId {
            font-size: 14px;
            font-weight: 550;
            color: var(--task-font-color);
            line-height: 20px;
          }
          .pId {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
          .selected {
            background: var(--task-bg-color);
            color: #fff;
          }
          .answered {
            background: var(--task-answer-bg-color);
            color: var(--task-answer-font-color);
          }
          .piPan {
            color: #000;
            cursor: pointer;
          }
          .piPan.answered {
            background: var(--task-answer-bg-color);
            color: var(--task-answer-font-color);
          }
          .piPan.selected {
            background: var(--task-bg-color);
            color: #fff;
          }
        }
      }
      .headline {
        width: 206px;
        display: block;
        margin: 0 auto;
        margin-bottom: 35px;
      }
      .content {
        width: 100%;
        height: auto;
        background-image: var(--main-left-content-bg);
        background-size: 100% 100%;
        padding-bottom: 5px;
        .issue {
          padding: 1px 23px 31px 23px;
          .label {
            margin: 10px 0 0 0;
            padding: 10px;
            border-radius: 4px;
            background-color: #f5f5f5;
            .image_steerBorder_bg {
              width: 120%;
              top: -5% !important;
              height: 145%;
              position: absolute;
            }
            .head {
              display: flex;
              justify-content: space-between;
              align-items: center;
              span {
                font-size: 16px;
                font-weight: bold;
                color: #252f38;
                line-height: 27px;
                font-family: '宋体';
              }
              .el-icon-arrow-down,
              .el-icon-arrow-up {
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
              }
            }
            .list {
              padding-top: 10px;
              position: relative;
              // .image_steerBorder_bg{
              //   width: 60%;
              //   height: 300px;
              //   background: rgba(0, 0, 0, 0.6);
              //   z-index: 103;
              //   margin: 0 20%;
              //   position: absolute;
              //   img{
              //     width: 60px;
              //     // height: 40px;
              //     right: 6%;
              //     bottom: 2%;
              //     position: absolute;
              //   }
              // }
              .image {
                width: 100%;
                margin: 0 auto;
                position: relative;
                .image_steerBorder_bg {
                  width: 65%;
                  height: 440px;
                  left: -20px;
                  // background: rgba(0, 0, 0, 0.6);
                  z-index: 103;
                  margin: -120px 20%;
                  position: absolute;
                }
                .image_steerButton_bg {
                  width: 60px;
                  // height: 40px;
                  right: 23%;
                  bottom: 2%;
                  position: absolute;
                }
                > img {
                  width: 60%;
                }
                .icon {
                  width: 80px;
                  bottom: 10px;
                  right: 22%;
                  position: absolute;
                  cursor: pointer;
                }
              }
              .image.steerBorder::after {
                content: '';
                width: 60%;
                height: 300px;
                top: 0;
                margin-left: 20%;
                display: inline-block;
                background: rgba(0, 0, 0, 0.6);
                position: absolute;
              }
              .answerList {
                span {
                  font-size: 16px;
                }
              }
            }
          }
          .list {
            font-size: 16px;
            font-weight: 400;
            color: #252f38;
            line-height: 27px;
            margin: 10px 0 0 0;
            font-family: '宋体';
            position: relative;
            .schoolImg {
              position: relative;
              // z-index: 1;
              cursor: url('./../../../../assets/exam/schoolImg/dianji.png') -30 -30, default;
              .schoolImg img {
                width: 90%;
              }
              .icon {
                width: 80px;
              }
              .school_dot {
                width: 90px;
                height: 40px;
                z-index: 5;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                img {
                  width: 15px;
                  height: 18px;
                  margin: -6px 2px 0 0;
                }
                span {
                  font-size: 12px;
                  transform: scale(0.9);
                  transform-origin: 0 0; /* 左对齐 */
                  font-weight: 560;
                  -webkit-text-stroke: 0.06px #fff;
                }
                .line {
                  width: 2px;
                  height: 110px;
                  background-color: #000;
                  position: absolute;
                }
                .dot_name {
                  font-size: 20px;
                  position: absolute;
                  border: 1px solid #ccc;
                  border-radius: 10px;
                  padding: 5px;
                }
              }
              .school_dot:not(.school_dot_no_flag):hover {
                img {
                  content: url('./../../../../assets/exam/qizi_icon_dian@2x.png');
                }
                span {
                  color: #04b6c9;
                }
              }
              .school_dot_no_flag {
                img {
                  visibility: hidden;
                }
              }
            }
            .video {
              position: absolute;
              width: 60%;
              // height: 50%;
              top: 35%;
              left: 20%;
              z-index: 6;
              video {
                width: 100%;
                height: 100%;
                object-fit: fill;
              }
              .el-icon-circle-close {
                position: absolute;
                font-weight: bold;
                color: black;
                right: -30px;
                top: -15px;
                cursor: pointer;
                z-index: 5;
              }
            }
            img {
              width: 60%;
              margin: 0 auto;
              display: block;
            }
            .image_steerBorder_bg {
              width: 85%;
              position: absolute;
              left: 7.5%;
              margin-top: -20px;
            }
            .icon {
              width: 80px;
              bottom: 10px;
              right: 20%;
              position: absolute;
              cursor: pointer;
            }
            .image_steerBorder_bubble_bg {
              width: 100%;
              height: 80px;
              left: -20px;
              top: 5px;
              z-index: 101;
              border: none;
              position: absolute;
              img {
                display: inline-block;
                &:nth-child(1) {
                  width: 80%;
                  height: 80px;
                }
                &:nth-child(2) {
                  width: 35%;
                  left: 80%;
                  top: 40px;
                  position: absolute;
                }
                &:nth-child(3) {
                  width: 35%;
                  left: 80%;
                  top: 40px;
                  position: absolute;
                }
              }
            }
            .answerList {
              // min-width: 200px;
              // max-width: 100%;
              width: 100%;
              min-height: 50px;
              margin-top: 10px;
              line-height: 1.1;
              // border: 1px solid #B1C6D2;
              // border-radius: 25px;
              // padding: 5px;
              // margin-right: 30px;
              // display: inline-block;
              .image_steerBorder_bg {
                width: 100%;
                height: 80px;
                left: -20px;
                top: 5px;
                z-index: 101;
                border: none;
                position: absolute;
                img {
                  display: inline-block;
                  &:nth-child(1) {
                    width: 80%;
                    height: 80px;
                  }
                  &:nth-child(2) {
                    width: 35%;
                    left: 80%;
                    top: 40px;
                    position: absolute;
                  }
                  &:nth-child(3) {
                    width: 35%;
                    left: 80%;
                    top: 40px;
                    position: absolute;
                  }
                }
              }
              div {
                min-width: 200px;
                max-width: 100%;
                min-height: 50px;
                border: 1px solid #b1c6d2;
                border-radius: 25px;
                padding: 5px;
                margin-right: 30px;
                display: inline-block;
                span {
                  width: 100%;
                  height: 100%;
                  padding: 5px;
                  cursor: move;
                  font-size: 20px;
                  // line-height: 18px;
                  border-radius: 25px;
                  display: inline-block;
                  padding: 10px 15px;
                  word-wrap: break-word;
                  word-break: break-all;
                }
              }
            }
            .answerList div:hover {
              > span {
                background-color: #e9e9e9;
              }
            }
            .title {
              text-align: center;
              font-weight: 600;
            }
          }
          .list.stormwater {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 0, 0, 0.7);
            z-index: 9;
            cursor: zoom-out;
            .schoolImg {
              .image_steerBorder_bg {
                width: 100%;
                top: 0;
                position: absolute;
              }
              img {
                width: 60vw;
                max-height: 90vh;
              }
              .icon {
                width: 80px;
                bottom: 5%;
                right: 5%;
                position: absolute;
                cursor: pointer;
              }
              .school_dot {
                width: 110px;
                height: 40px;
                z-index: 5;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                img {
                  width: 18px;
                  height: 18px;
                  margin: -8px 2px 0 0;
                }
                span {
                  font-size: 20px;
                  font-weight: 560;
                }
              }
            }
            .video {
              top: 30%;
              width: 40%;
              left: 30%;
              .el-icon-circle-close {
                font-size: 30px;
                right: -40px;
                top: -20px;
              }
            }
          }
          .list.text_abstract {
            font-family: '楷体';
            // text-indent: 2em;
          }
          .abstract {
            font-family: '楷体';
            text-indent: 0em !important;
          }
          .list.min {
            display: none;
          }
          .list.img_small {
            display: flex;
            justify-content: space-around;
            > div {
              display: flex;
              align-items: flex-end;
              position: relative;
              img {
                width: 80%;
              }
              .icon {
                right: 10%;
              }
            }
          }
          .steerBorder {
            position: relative;
            .image_steerBorder_bg {
              top: -21%;
              left: 0;
              width: 100%;
              position: absolute;
            }
            .image_steerVideoBorder_bg {
              top: -32%;
              left: 0;
              width: 100%;
              height: 110%;
              position: absolute;
            }
          }
          .showVideo {
            padding: 0 27px;
            height: 360px;
            height: 3.6rem;
            margin-top: 12px;
            position: relative;
            video {
              width: 100%;
              height: 100%;
            }
            .playButton {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(0, 0, 0, 0.25);
              .play {
                width: 50px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
  .forewordLeft {
    width: 100%;
    .stem.pipan {
      width: 99%;
    }
  }
  .right {
    width: 45%;
    background-image: var(--main-right-content-bg);
    background-size: 100% 100%;
    padding: 0 28px 100px 28px;
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    .steer_bg_kuang {
      width: 45%;
      height: 360px;
      z-index: 105;
      right: 0;
      margin-top: -100px;
      position: absolute;
    }
    .steer_bg_up_kuang.steer_bg_kuang {
      margin-top: -30px;
    }
    .steer_bg_left_kuang.steer_bg_kuang {
      width: 51%;
      height: 300px;
      margin-top: -30px;
    }
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      margin-bottom: 30px;
      img {
        height: 46px;
      }
    }
    .countDown {
      width: 100%;
      margin-top: 17px;
      display: flex;
      align-items: center;
      height: 26px;
      span {
        padding-right: 10px;
        font-size: 18px;
        font-weight: 600;
        color: #4F6A5A;
        line-height: 25px;
      }
      > div {
        flex: 1;
        height: 8px;
        background: rgba(143, 166, 182, 0.19);
        border-radius: 9px;
        position: relative;
        .over {
          position: absolute;
          top: 0px;
          left: 0;
          width: 50%;
          // background-image: url(~@/assets/exam/bj_jindu@2x.png);
          background-size: auto 100%;
          background-color: #4F6A5A;
          height: 100%;
          border-radius: 4px;
        }
        // .over.showTip{
        //   background: url(~@/assets/exam/bj_jindu_1@2x.png) no-repeat;
        //   background-size: cover;
        // }
        .current {
          position: absolute;
          left: 50%;
          margin-left: -6px;
          top: -2px;
          width: 12px;
          height: 12px;
          background: linear-gradient(87deg, #688b76 0%, #4F6A5A 100%);
          border-radius: 50%;
        }
        .current::after {
          content: '';
          position: absolute;
          left: -2px;
          top: -2px;
          width: 16px;
          height: 16px;
          background: linear-gradient(87deg, #4f6a5a 0%, #81a991 100%);
          opacity: 0.5;
          border-radius: 50%;
        }
        // .current.showTip{
        //   background-image: url(~@/assets/exam/icon_qiu.png);
        //   background-size: cover;
        // }
        // .current.showTip::after{
        //   background-image: url(~@/assets/exam/icon_qiu.png);
        //   background-size: cover;
        //   // opacity: 1;
        // }
      }
    }
    .tip {
      height: 60px;
      position: relative;
      bottom: 5px;
      padding-bottom: 10px;
      .bjTip {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .message {
        width: 100%;
        height: 100%;
        z-index: 5;
        position: relative;
        padding-left: 20px;
        display: flex;
        color: #fff;
        align-items: center;
        span {
          margin-left: 10px;
        }
      }
    }
    .inputNmae {
      width: 55%;
      margin-top: -380px;
      float: right;
    }
    .select {
      padding: 20px 0 0 40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .steer_bg_kuang {
        width: 100%;
        // top: -46%;
        margin-top: -10px !important;
        position: absolute;
      }
      .selectRadio {
        width: 100%;
        display: flex;
        align-items: center;
        /deep/ .el-radio__label {
          // padding-top: 4px;
          font-size: 16px;
        }
        span {
          font-size: 16px;
        }
        /deep/.el-input,
        /deep/.el-input__inner {
          width: 160px;
          background: transparent;
          border: 0;
          border-bottom: 1px solid;
          padding: 0;
          height: 25px;
          line-height: 25px;
        }
        .selected_radio {
          /deep/.el-input__inner {
            color: #409eff !important;
          }
        }
      }
      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          width: 50%;
          display: flex;
          align-items: center;
          .el-checkbox__label {
            padding-top: 4px;
            font-size: 16px;
          }
        }
      }
    }
    .bubble {
      display: flex;
      flex-wrap: wrap;
      .steer_bg_kuang {
        width: 23%;
        height: auto;
        left: 23.5%;
        margin-top: -20px;
        position: absolute;
        overflow: clip;
        display: flow-root;
        overflow-clip-margin: 500px;
      }
      .image_steerBorder_bubble_bg {
        width: 100%;
        height: 100%;
        z-index: 102;
        border-radius: 20px;
        text-align: center;
        position: absolute;
        background: rgba(0, 0, 0, 0.6);
        img {
          width: 140px;
          // height: 40px;
          top: 80%;
          position: relative;
        }
      }
      .bubble_list {
        width: 18%;
        min-height: 340px;
        background-size: 100% 100%;
        // overflow: hidden;
        margin-right: 2%;
        margin-top: 10px;
        border-radius: 20px;
        background: url('./../../../../assets/exam/bj_tianjia.png') no-repeat;
        background-size: cover;
        position: relative;
        .el-icon-error {
          position: absolute;
          right: -8px;
          top: -8px;
          z-index: 9;

          cursor: pointer;
        }
        .el-icon-error:hover {
          color: #d9001b;
        }
        .bubble_title {
          width: 100%;
          height: 40px;
          line-height: 30px;
          text-align: center;
          padding: 8px 10px;
          outline: none;
          /deep/.el-input__inner {
            width: 100%;
            height: 25px;
            font-size: 20px;
            display: inline-block;
            font-family: '楷体';
            overflow: hidden;
            // text-overflow: ellipsis;
            white-space: nowrap;
            border: 0;
            border-bottom: 1px solid #dcdfe6;
            background: transparent;
            text-align: center;
            color: #fff;
          }
        }
        .bubble_answer {
          width: 100%;
          height: calc(100% - 44px);
          margin-top: 6px;
          background: url('./../../../../assets/exam/bj_11.png') no-repeat;
          background-size: 100% 100%;
          background-position: center;
          border-radius: 20px;
          padding: 15px 10px;
          position: relative;
          .bubble_answer_list {
            height: calc(100% - 60px);
            // overflow-y: auto;
            .bubble_answer_list_input {
              width: 100%;
              padding: 5px;
              z-index: 10;
              display: flex;
              border: 1px solid #b1c6d2;
              border-radius: 25px;
              margin-top: 5px;
              span {
                font-size: 18px;
                font-weight: 400;
                padding: 10px 0 10px 10px;
                border-top-left-radius: 25px;
                border-bottom-left-radius: 25px;
              }
              div {
                width: 100%;
                min-height: 20px;
                padding: 10px 15px;
                display: block;
                font-size: 18px;
                font-weight: 400;
                border-radius: 25px;
                // border-top-right-radius: 25px;
                // border-bottom-right-radius: 25px;
                word-wrap: break-word;
                word-break: break-all;
                outline: none;
                z-index: 2;
                cursor: text;
              }
            }
            .bubble_answer_list_input:hover {
              cursor: move;
              span {
                background-color: #e9e9e9;
              }
              > div {
                background-color: #e9e9e9;
              }
            }
          }
          // .bubble_answer_list::-webkit-scrollbar {
          //   display: none;
          // }
          .bubble_answer_input {
            width: 100%;
            height: 60px;
            // top: 85%;
            border-radius: 20px;
            // background: #F5F8F9;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .record {
              max-height: 100%;
              width: 50%;
              // margin-top: 0;
              padding: 0 !important;
              background: transparent !important;
              margin: 0 auto;
              min-height: auto;
            }
            .textInput {
              width: 50%;
              display: flex;
              justify-content: center;
              > div {
                width: 70px;
                height: 39px;
                border: 1px solid #b1c6d2;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
        .steer_bg_kuang {
          top: -1%;
          left: -64.5%;
          width: 180%;
          height: 114%;
          max-width: 200%;
          position: absolute;
        }
      }
    }
    .draw_img_box {
      .steer_bg_kuang {
        width: 51%;
        height: 610px;
        left: 48.5%;
        margin-top: -45px;
        position: absolute;
      }
      .draw_img {
        width: 100%;
      }
      .draw_img_button {
        width: 70%;
        height: 40px;
        margin: 0 auto;
        background-color: #ededed;
        border-radius: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        > div {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          position: relative;
          span {
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
          }
          .line {
            width: 2px;
            height: 20px;
            background-color: #d8d8d8;
            margin-left: 10px;
            display: inline-block;
            border-radius: 2px;
            right: 0;
            position: absolute;
          }
        }
      }
      .steerBorder.draw_img_button {
        width: 30%;
        bottom: 20px;
        left: 65%;
        position: absolute;
      }
    }
    .dragType {
      width: 100%;
      height: 200px;
      border: 1px solid #eee;
      background: #f5f5f5;
      border-radius: 6px;
      margin-top: 20px;
      .type {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        img {
          height: 24px;
        }
      }
      .typeSmall {
        position: relative;
        width: 90%;
        margin: 0 auto;
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        > img {
          height: 60px;
          position: relative;
          top: 0;
          cursor: move;
        }
      }
    }
    .title {
      text-indent: 2em;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 28px;
    }
    .title:last-child {
      margin-top: 22px;
    }
    .image_steerBorder_bg {
      width: 42%;
      height: 235px;
      background: rgba(0, 0, 0, 0.6);
      z-index: 103;
      position: absolute;
      img {
        width: 120px;
        // height: 40px;
        left: 3%;
        bottom: 6.7%;
        position: absolute;
      }
    }
    .imgType {
      width: 70%;
      display: block;
      margin: 0 auto;
      margin-top: 22px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-top: 12px;
    }
    .tip {
      padding-top: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #666d73;
      line-height: 22px;
    }
    .recordBox {
      width: 100%;
      font-size: 18px;
      position: relative;
      margin-top: 20px;
    }
    .next {
      width: 273px;
      height: 51px;
      background: #f8f9ff;
      border-radius: 22px;
      display: flex;
      background-image: var(--main-right-next-btn);
      background-size: 100% 100%;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
  }
  .right.end {
    padding: 50px 0;
    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        margin-bottom: 30px;
      }
      .text {
        > img {
          max-width: 550px;
          // height: 25px;
        }
      }
      .answer_complete {
        font-size: 40px;
        font-family: '宋体';
        font-weight: bold;
        color: var(--button-bg-color);
        margin-bottom: 12px;
      }
    }
    .next {
      margin-top: 80px;
    }
  }
  .imgBig {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    cursor: zoom-out;
    > img {
      width: 60vw;
      max-height: 90vh;
    }
    .icon {
      width: 80px;
      bottom: 19%;
      right: 20%;
      position: absolute;
      cursor: pointer;
    }
  }
  .title.steerBorder,
  .select.steerBorder {
    background-image: url('~@/assets/exam/bj_zuoda_yao@2x.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    &:first-child {
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
    }
  }
  .select.steerBorder {
    &:first-child {
      border-radius: 0;
      border-bottom-left-radius: 25px;
      border-bottom-right-radius: 25px;
    }
  }
  .schoolImg.steerBorder,
  .draw_img_box.steerBorder,
  .steerBorder {
    z-index: 101;
    position: relative;
  }

  /deep/.el-radio__input.is-checked .el-radio__inner{
    border-color: var(--button-bg-color);
    background: linear-gradient(180deg, var(--button-bg-color) 0%, var(--button-bg-color) 100%);
  }
  /deep/.el-radio__input.is-checked+.el-radio__label{
    color: var(--button-bg-color);
  }
  /deep/.el-input__inner {
    color: var(--button-bg-color);
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: var(--button-bg-color);
    background: linear-gradient(180deg, var(--button-bg-color) 0%, var(--button-bg-color) 100%);
  }
  /deep/.el-checkbox__input.is-checked+.el-checkbox__label{
    color: var(--button-bg-color);
  }
}
  /deep/.el-dialog {
    box-shadow: 0 0 0 !important;
  }
  /deep/.el-dialog--center {
    background: var(--main-dialog-bg);
    background-size: 100% 100%;
    .el-dialog__body {
      .text {
        width: 70%;
        margin: 20px auto 0 auto;
        font-size: 18px;
        color: #000;
        text-align: center;
      }
    }
    .el-dialog__footer {
      .dialog-footer {
        margin-bottom: 30px;
        .el-button {
          font-size: 16px;
          width: 75px;
          height: 35px;
          padding: 5px;
          color: var(--button-bg-color);
          border-color: #ccc;
          > span {
            font-size: 16px;
          }
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
        .el-button.el-button--primary,
        .el-button--primary:focus,
        .el-button--primary:hover {
          color: #fff;
          background-color: var(--button-bg-color);
          border-color: var(--button-bg-color);
          margin-right: 10px;
        }
      }
    }
  }
</style>
<style lang="less">
.replaceContent {
  width: 100%;
  overflow: hidden;
  padding: 10px 15px;
  word-wrap: break-word;
  line-height: 1.4;
  position: relative;
}
</style>
